import React, { createContext, useContext, useState } from "react";
import { auth } from "../services/firebase";
import { signOut } from "firebase/auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // Initialize from localStorage if available
    const storedUser = localStorage.getItem("superadmin");
    return storedUser ? { mobile: storedUser } : null;
  });

  const logout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem("superadmin");
      setUser(null);
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      setUser,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
